/** Varsayılan tema renkleri — Uygulama Yönetimi’nde override edilebilir */
export const DEFAULT_THEME_COLORS = {
  kamuBlue: "#006bd6",
  kamuBlueHover: "#0057b3",
  kamuGreen: "#009a52",
  kamuGreenHover: "#008245",
  kamuDark: "#0f172a",
  kamuHeader: "#1a2234",
  compactBg: "#0b1329",
  indigo: "#4f46e5",
  danger: "#dc2626",
  amber: "#f59e0b",
  emerald: "#10b981",
};

export const THEME_COLOR_META = [
  { key: "kamuBlue", label: "Ana mavi" },
  { key: "kamuBlueHover", label: "Ana mavi (hover)" },
  { key: "kamuGreen", label: "Yeşil / başarı" },
  { key: "kamuGreenHover", label: "Yeşil (hover)" },
  { key: "kamuDark", label: "Koyu zemin" },
  { key: "kamuHeader", label: "Header" },
  { key: "compactBg", label: "Compact arka plan" },
  { key: "indigo", label: "Indigo vurgu" },
  { key: "danger", label: "Tehlike / hata" },
  { key: "amber", label: "Uyarı" },
  { key: "emerald", label: "Emerald" },
];

function cssVar(name, fallback) {
  return `var(--wunity-${name}, ${fallback})`;
}

export const portalTokens = {
  kamuBlue: cssVar("kamuBlue", DEFAULT_THEME_COLORS.kamuBlue),
  kamuBlueHover: cssVar("kamuBlueHover", DEFAULT_THEME_COLORS.kamuBlueHover),
  kamuGreen: cssVar("kamuGreen", DEFAULT_THEME_COLORS.kamuGreen),
  kamuGreenHover: cssVar("kamuGreenHover", DEFAULT_THEME_COLORS.kamuGreenHover),
  kamuDark: cssVar("kamuDark", DEFAULT_THEME_COLORS.kamuDark),
  kamuHeader: cssVar("kamuHeader", DEFAULT_THEME_COLORS.kamuHeader),
  compactBg: cssVar("compactBg", DEFAULT_THEME_COLORS.compactBg),
  indigo: cssVar("indigo", DEFAULT_THEME_COLORS.indigo),
  slate50: "#f8fafc",
  slate100: "#f1f5f9",
  slate200: "#e2e8f0",
  slate300: "#cbd5e1",
  slate400: "#94a3b8",
  slate500: "#64748b",
  slate600: "#475569",
  slate700: "#334155",
  slate800: "#1e293b",
  slate900: "#0f172a",
  white: "#ffffff",
  danger: cssVar("danger", DEFAULT_THEME_COLORS.danger),
  amber: cssVar("amber", DEFAULT_THEME_COLORS.amber),
  emerald: cssVar("emerald", DEFAULT_THEME_COLORS.emerald),
  fontFamily: "'Inter', 'Roboto', sans-serif",
  navWidth: 64,
  listWidth: 320,
  compactWidth: 420,
  compactHeight: 720,
  radiusSm: 8,
  radiusMd: 12,
  radiusLg: 16,
  radiusXl: 20,
};

/** CSS değişkenlerini :root’a yazar; eksiklerde default kullanılır */
export function applyThemeCssVars(themeColors) {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  const merged = { ...DEFAULT_THEME_COLORS, ...(themeColors || {}) };
  Object.keys(DEFAULT_THEME_COLORS).forEach((key) => {
    const val = String(merged[key] || DEFAULT_THEME_COLORS[key]).trim();
    if (/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/.test(val)) {
      root.style.setProperty(`--wunity-${key}`, val);
    } else {
      root.style.setProperty(`--wunity-${key}`, DEFAULT_THEME_COLORS[key]);
    }
  });
}

export default portalTokens;
